import { createFileRoute } from '@tanstack/react-router'
import { BadgeCheck } from 'lucide-react'
import { z } from 'zod'
import { ApprovalsScreen } from '@/screens/improve/SCR-029-approvals'

export const Route = createFileRoute('/_app/w/$ws/approvals')({
  staticData: { screen: {"id":"SCR-029","title":"Approvals","group":"Improve","perm":"approval.review","order":6,"description":"Actions waiting for a person to approve, bound to exactly what will happen.", icon: BadgeCheck } },
  validateSearch: z.object({ view: z.enum(['pending', 'history']).optional(), a: z.string().max(200).optional() }),
  component: ApprovalsScreen,
})
